import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dialog: {
    zIndex: `1300 !important`,

    '& .MuiPaper-root': {
      width: '90%',
      maxWidth: 600,
      height: '90vh',
    },
  },
  container: {
    position: 'relative',
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(4),
    },
  },
  subtitle: {
    color: theme.palette.text.primary,
    [theme.breakpoints.down('lg')]: {
      textAlign: 'center',
      paddingTop: theme.spacing(2),
    },
  },

  inputContainer: {
    [theme.breakpoints.up('lg')]: {
      margin: theme.spacing(1),
    },
  },

  searchContainer: {
    margin: theme.spacing(1),
  },

  formStyle: {
    position: 'relative',
    maxWidth: '1000px !important',
    overflow: 'visible !important',
    height: 'auto',
  },
  titleStyle: {
    fontSize: '18px !important',
    fontWeight: 'bold',
  },
  screenWidth: {
    width: '100%',
    '& .MuiInput-formControl.Mui-disabled, .MuiInputLabel-formControl': {
      color: theme.palette.text.primary,
    },
    '& .Mui-disabled.MuiInputBase-formControl .MuiSelect-icon': {
      display: 'none',
    },
    '& .Mui-disabled.MuiInput-underline:before': {
      border: `none !important`,
    },
  },
  screenContainer: {
    maxWidth: 'none !important',
  },
  screenContainerMobile: {
    maxWidth: 'none !important',
  },
  dropZone: {
    borderRadius: 10,
  },
}));

export const listStyles = makeStyles((theme) => ({
  listItem: {
    // boxShadow: `0px 0px 4px rgba(0,0,0,0.2)`,
    borderTop: `${theme.palette.action.disabled} solid 1px`,
    position: 'relative',
  },
  marginLeft: {
    marginLeft: theme.spacing(2),
  },
  marginRight: {
    marginRight: theme.spacing(4),
  },
  tagContainer: {
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.text.primary,
  },
  tagActive: {
    color: theme.colors.blue,
  },
  checkpointText: {
    '& .MuiTypography-root': {
      fontSize: `14px !important`,
    },
  },
}));

export default useStyles;
